<template>
  <div class="tab-bar">
    <div 
      v-for="tab in tabs" 
      :key="tab.path"
      class="tab-item"
      :class="{ active: currentPath === tab.path }"
      @click="navigate(tab.path)"
    >
      <div class="tab-icon">{{ tab.icon }}</div>
      <div class="tab-label">{{ tab.label }}</div>
      <span v-if="tab.badge" class="badge-dot"></span>
    </div>
  </div>
</template>

<script setup>
import { computed, ref, onMounted, onUnmounted } from 'vue'
import { useRouter, useRoute } from 'vue-router'
import { useSound } from '@/composables/useSound'

const router = useRouter()
const route = useRoute()
const { withSound } = useSound()

const currentPath = computed(() => route.path)
const hasUnreadServiceMessage = ref(false)

// 监听未读消息更新事件
function handleUnreadUpdate() {
  hasUnreadServiceMessage.value = true
}

// 进入客服页面时清除未读标记
function handleServiceRouteChange() {
  if (route.path === '/service') {
    hasUnreadServiceMessage.value = false
  }
}

const tabs = computed(() => [
  { path: '/home', icon: '🏠', label: '主页' },
  { path: '/ranking', icon: '🏆', label: '排行榜' },
  { path: '/hall', icon: '🎮', label: '大厅' },
  { path: '/service', icon: '💬', label: '客服', badge: hasUnreadServiceMessage.value },
  { path: '/profile', icon: '👤', label: '我的' }
])

const navigate = withSound((path) => {
 

 
  
  router.push(path)
  // 如果进入客服页面，清除未读标记
  if (path === '/service') {
    hasUnreadServiceMessage.value = false
  }
})

onMounted(() => {
  window.addEventListener('service:unread_updated', handleUnreadUpdate)
  // 监听路由变化
  router.afterEach((to) => {
    if (to.path === '/service') {
      hasUnreadServiceMessage.value = false
    }
  })
})

onUnmounted(() => {
  window.removeEventListener('service:unread_updated', handleUnreadUpdate)
})
</script>

<style scoped>
.tab-bar {
  position: fixed;
  bottom: 0;
  left: 0;
  right: 0;
  height: var(--tabbar-height, 60px);
  padding-bottom: env(safe-area-inset-bottom);
  background: rgba(5, 7, 20, 0.96);
  border-top: 1px solid rgba(255, 255, 255, 0.06);
  display: flex;
  align-items: center;
  justify-content: space-around;
  z-index: 1000;
  backdrop-filter: blur(10px);
}

:global(#app.pc-viewport .pc-container) .tab-bar {
  position: absolute;
}

.tab-item {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 4px;
  color: #7e89b5;
  cursor: pointer;
  position: relative;
  padding: 4px 12px;
  transition: color 0.3s;
}

.tab-item.active {
  color: #5eead4;
}

.tab-icon {
  font-size: 22px;
  width: 32px;
  height: 32px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 8px;
  transition: all 0.3s;
}

.tab-item.active .tab-icon {
  background: radial-gradient(circle at top, rgba(94, 234, 212, 0.2), transparent);
}

.tab-label {
  font-size: 11px;
}

.badge-dot {
  position: absolute;
  top: 2px;
  right: 8px;
  width: 8px;
  height: 8px;
  border-radius: 50%;
  background: #f97373;
  box-shadow: 0 0 0 2px rgba(249, 115, 115, 0.3);
}
</style>

